// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import FullPageSignupLoader from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignupLoader';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/components/AccountSwitcherLoginModal/Modal';
import { Box } from 'gestalt';
import { SignupSource } from 'app/common/react/components/growth/unauth/signup/constants';

export const AccountSwitcherLoginModal = (props: {
  email?: string,
  container: string,
  customTaglineText?: string,
  onClose?: () => void,
}) => (
  <Modal
    onCloseClick={() => {
      if (props.onClose) {
        props.onClose();
      }
    }}
    renderContent={() => (
      <Box display="flex" justifyContent="center" flex="grow">
        <FullPageSignupLoader
          container={props.container}
          email={props.email}
          isAccountSwitch
          isModal
          type={SignupSource.login}
          signupSource={SignupSource.login}
          customLoginTagline={
            props.customTaglineText ||
            i18n._(
              'Add account',
              'Short text on the button that allows a user to log in to another Pinterest account',
            )
          }
        />
      </Box>
    )}
  />
);

export default connect<*, *, _, _, _, _>()(AccountSwitcherLoginModal);
